module.exports = __webpack_public_path__ + "static/media/yardnapha-runout.2c3c7010.png";